import React from 'react'

import { DatePicker } from 'antd'

import moment from 'moment'
import { RangePickerValue } from 'antd/lib/date-picker/interface'
const { RangePicker } = DatePicker

interface IProps {
  value?: RangePickerValue
  minStartDate?: moment.Moment
  maxEndDate?: moment.Moment
  onChange: (dates: RangePickerValue) => void
}

export function CustomDatePicker({ value, minStartDate, maxEndDate, onChange }: IProps) {
  const disabledDate = (current: moment.Moment | null) => {
    if (!current) return false

    const currentDate = moment(current)
    const isBeforeMinDate = (minStartDate && currentDate.isBefore(minStartDate)) || false
    const isAfterMaxDate = (maxEndDate && currentDate.isAfter(maxEndDate)) || false

    return isBeforeMinDate || isAfterMaxDate
  }

  let startToEndValue = value
  if (value && value[0] && value[1]) {
    startToEndValue = [value[0].startOf('day'), value[1].endOf('day')]
  }

  return (
    <RangePicker
      value={startToEndValue}
      ranges={{
        Today: [moment().startOf('day'), moment().endOf('day')],
        'Past 6 months': [moment().subtract(6, 'month'), moment()],
        'Past year': [moment().subtract(365, 'days').startOf('day'), moment().endOf('day')],
        'Past two years': [moment().subtract(2, 'years').startOf('day'), moment().endOf('day')],
      }}
      disabledDate={disabledDate}
      onChange={onChange}
    />
  )
}
